import { Search } from "lucide-react";
import { useStudio } from "@/lib/studio";

// Mobile: a floating search bar pinned above the home indicator. Desktop uses the search field in the header.
export function FloatingSearch() {
  const { openSearch } = useStudio();
  return (
    <div className="pointer-events-none fixed inset-x-0 z-30 mx-auto max-w-md px-4 lg:hidden" style={{ bottom: "calc(env(safe-area-inset-bottom) + 14px)" }}>
      <button type="button" onClick={openSearch} data-testid="floating-search-bar"
        className="pointer-events-auto flex h-[52px] w-full items-center gap-3 rounded-full border border-white/15 bg-ink-850/90 px-5 text-[15px] text-zinc-400 shadow-[0_16px_40px_rgba(0,0,0,0.85)] backdrop-blur-xl transition-colors hover:border-white/30 hover:text-white">
        <Search className="h-5 w-5" />
        Search
      </button>
    </div>
  );
}
